import React from 'react';
import { useIntl } from 'react-intl';
import { Fade, Box, Tabs, Tab, Paper } from '@mui/material';
import removeImgsFromBody from '../../Helpers/StringsFormatting/removeImgsFromBody';
import renderButtons from '../../Helpers/StringsFormatting/renderButtons';

const ContentBodyBox = function ContentBodyBox({
  transition = true,
  visibility = true,
  content = '',
  height = '100%',
  styles = null,
  removeHtml = false,
  tabs = [],
  tabValue = 0,
  onChangeTabValue = () => {},
}) {
  const intl = useIntl();

  function createHTML() {
    const stringContent = removeHtml
      ? renderButtons(removeImgsFromBody(content))
      : renderButtons(content);
    return { __html: stringContent };
  }
  return (
    <Fade in={visibility && transition} appear={transition}>
      <Paper
        variant="outlined"
        sx={{
          backgroundColor: 'transparent',
          boxSizing: 'inherit',
          width: '100%',
          display: visibility ? 'flex' : 'none',
          flexDirection: 'column',
          height,
          borderRadius: '5px',
          ...styles?.root,
        }}
      >
        {tabs.length > 0 && (
          <Tabs
            value={tabValue}
            onChange={onChangeTabValue}
            variant="fullWidth"
          >
            {tabs.map((tab) => (
              <Tab key={tab} value={tab} label={intl.messages[tab] ?? tab} />
            ))}
          </Tabs>
        )}
        <Box
          sx={{
            height: '100%',
            width: '100%',
            overflow: 'auto',
            p: '16px',
            ...(styles?.box || {}),
          }}
        >
          <div style={styles?.content} dangerouslySetInnerHTML={createHTML()} />
        </Box>
      </Paper>
    </Fade>
  );
};

export default ContentBodyBox;
